import { createAction, props } from '@ngrx/store';
import { AppModel } from '../shared/models/AppModel';

export const applicantSourceSet = createAction('[App] Applicant Source', props<{id: number}>());
export const initialized = createAction('[App] Initialized', props<{ appModel: AppModel }>());
